export default __webpack_public_path__ + "static/media/pages.22bca670.svg";